import { ProcessErrorObject } from './process-error-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

export enum TimeStatus {
  COMPLETED_EXCEEDED = 'completedExceeded',
  COMPLETED = 'completed',
  SKIPPED = 'skipped',
  CANCELLED = 'cancelled',
  EXCEEDED = 'exceeded',
  NOT_EXCEEDED = 'notExceeded',
  NOT_STARTED = 'waitingStart'
}

export class ProcessActivityObject {

  private type: string;
  private status: string;

  private started: boolean;
  private completed: boolean;
  private skipped: boolean;
  private cancelled: boolean;
  private timeStatus: TimeStatus;
  private startTimeStamp: Date;
  private endTimeStamp: Date;

  constructor(type: string, status: string, private errorList: Array<ProcessErrorObject>, private numberOfErrors: number,
    private actualDuration: number, private expectedDuration: number,
    private startDate: Date, private completedDate: Date, private information: string,
    completed: boolean, skipped: boolean, cancelled: boolean,
    started: boolean) {

    this.type = type != null ? type.toUpperCase() : null;
    this.status = status != null ? status.toUpperCase() : null;

    this.started = started != null ? started : null;
    this.completed = completed != null ? completed : false;
    this.skipped = skipped != null ? skipped : false;
    this.cancelled = cancelled != null ? cancelled : false;

    if (actualDuration === 0) {
      this.timeStatus = TimeStatus.NOT_STARTED;
    } else {
      if (completed) {
        if (actualDuration > expectedDuration) {
          this.timeStatus = TimeStatus.COMPLETED_EXCEEDED;
        } else { this.timeStatus = TimeStatus.COMPLETED; }
      } else {
        if (skipped) { this.timeStatus = TimeStatus.SKIPPED; } else {
          if (cancelled) { this.timeStatus = TimeStatus.CANCELLED; } else {
            if (actualDuration > expectedDuration) { this.timeStatus = TimeStatus.EXCEEDED; } else {
              this.timeStatus = TimeStatus.NOT_EXCEEDED;
            }
          }
        }
      }
    }
    this.information = information;
  }

  public static create(): ProcessActivityObject {
    return new ProcessActivityObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, new Array<ProcessErrorObject>(), 0,
      0, 0, new Date(), new Date(), StringUtils.NOT_AVALIABLE, false, false, false, false);
  }

  public getType(): string {
    return this.type;
  }

  public getStatus(): string {
    return this.status;
  }

  public getErrorList(): Array<ProcessErrorObject> {
    return this.errorList;
  }

  public getErrorListSize(): number {
    return isNullOrUndefined(this.errorList) ? 0 : this.errorList.length;
  }

  public getNumberOfErrors(): number {
    return this.numberOfErrors;
  }

  public getActualDuration(): number {
    return this.actualDuration;
  }

  public getExpectedDuration(): number {
    return this.expectedDuration;
  }

  public getStartDate(): Date {
    return this.startDate;
  }

  public getCompletedDate(): Date {
    return this.completedDate;
  }

  public getStartTimeStamp(): Date {
    return this.startTimeStamp;
  }
  public getEndTimeStamp(): Date {
    return this.endTimeStamp;
  }

  public getInformation(): string {
    return !isNullOrUndefined(this.information) ? this.information : '';
  }

  public skipActivity(): void {
    this.skipped = true;
  }

  public setCancelled(cancelled: boolean): void {
    this.cancelled = cancelled;
  }

  public isSkipped(): boolean {
    return this.skipped;
  }

  public isCompleted(): boolean {
    return this.completed;
  }

  public setCompleted(completed: boolean): void {
    this.completed = completed;
  }

  public getTimeStatus(): TimeStatus {
    return this.timeStatus;
  }

  public isCancelled(): boolean {
    return this.cancelled;
  }

  public isStarted(): boolean {
    return this.started;
  }

  public steStarted(started: boolean): void {
    this.started = started;
  }

}
